var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6434 4.83339L5.1551 10.3217C4.99591 10.4755 4.86894 10.6594 4.7816 10.8627C4.69425 11.0661 4.64827 11.2848 4.64635 11.5061C4.64442 11.7274 4.68659 11.9468 4.77039 12.1516C4.8542 12.3565 4.97795 12.5426 5.13444 12.699C5.29093 12.8555 5.47701 12.9793 5.68184 13.0631C5.88667 13.1469 6.10613 13.1891 6.32743 13.1871C6.54873 13.1852 6.76743 13.1392 6.97077 13.0519C7.17411 12.9645 7.35802 12.8376 7.51176 12.6784L12.8568 7.19006C13.464 6.56138 13.7999 5.71937 13.7923 4.84538C13.7848 3.9714 13.4342 3.13535 12.8162 2.51733C12.1981 1.8993 11.3621 1.54874 10.4881 1.54114C9.61411 1.53355 8.77211 1.86953 8.14343 2.47672L2.7976 7.96422C1.85984 8.90198 1.33301 10.1739 1.33301 11.5001C1.33301 12.8262 1.85984 14.0981 2.7976 15.0359C3.73536 15.9736 5.00724 16.5005 6.33343 16.5005C7.65963 16.5005 8.9315 15.9736 9.86926 15.0359L15.0834 9.83339",
    stroke: "#F66700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.31ba1478b2eb9b9e6449e9ddc502054c.svg";
export { ForwardRef as ReactComponent };